module.exports = __webpack_public_path__ + "d8dd55d6358506db7ee528abe1030ee9.svg";